import { Inject, Injectable, Optional } from "@angular/core";
import { NZ_DATE_LOCALE, NZ_I18N, NzI18nService } from "ng-zorro-antd/i18n";
import { DateLocale, UiI18nInterface } from "../i18n.models";
import { locale as defaultLocale } from "../locales/en_US";

// Taken from https://dev.to/tipsy_dev/advanced-typescript-reinventing-lodash-get-4fhe
type GetFieldType<Obj, Path> = Path extends `${infer Left}.${infer Right}`
  ? Left extends keyof Obj
    ? GetFieldType<Exclude<Obj[Left], undefined>, Right> | Extract<Obj[Left], undefined>
    : undefined
  : Path extends keyof Obj
  ? Obj[Path]
  : undefined;

@Injectable({
  providedIn: "root",
})
export class UiI18nService extends NzI18nService {
  constructor(@Optional() @Inject(NZ_I18N) locale: UiI18nInterface, @Optional() @Inject(NZ_DATE_LOCALE) dateLocale: DateLocale) {
    super(locale || defaultLocale, dateLocale);
  }

  public getLocaleData<TPath extends string, TDefault = GetFieldType<UiI18nInterface, TPath>>(
    path: TPath,
    defaultValue?: TDefault
  ): GetFieldType<UiI18nInterface, TPath> | TDefault {
    return super.getLocaleData(path, defaultValue);
  }
}
